
export const WEAR_PARTS_BASE = "https://shop.fecon.com/collections/mulching-teeth"; // replace with your base

/**
 * Adds serialNumber as a query param to any URL.
 * If you prefer path-style (e.g., /buy/:serialNumber), use template replacement in wearPartsGroups.ts (shown below).
 */
export function withSerialQuery(url: string, serialNumber?: string): string {
  if (!serialNumber) return url;
  const sep = url.includes("?") ? "&" : "?";
  return `${url}${sep}serial=${encodeURIComponent(serialNumber)}`;
}

/**
 * Replaces :serialNumber in URL templates with the actual serialNumber.
 */
export function withSerialTemplate(urlTemplate: string, serialNumber?: string): string {
  return urlTemplate.replace(":serialNumber", encodeURIComponent(serialNumber ?? ""));
}
